import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import './Chat.css';

const ConversationList = ({ conversations, selectedConversation, onSelectConversation, onNewConversation }) => {
  const formatLastMessageTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = (now - date) / (1000 * 60 * 60);

    if (diffInHours < 24) {
      return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit'
      });
    } else if (diffInHours < 48) {
      return 'Yesterday';
    } else {
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    }
  };

  return (
    <div className="conversation-list">
      <div className="conversation-list-header">
        <h2>Conversations</h2>
        {onNewConversation && (
          <Tooltip title="Start New Conversation">
            <IconButton
              onClick={onNewConversation}
              size="small"
              sx={{
                backgroundColor: '#4caf50',
                color: 'white',
                '&:hover': { backgroundColor: '#388e3c' },
              }}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <div className="conversation-list-items">
        {conversations.length === 0 ? (
          <div className="no-conversations">
            <p>No conversations yet</p>
          </div>
        ) : (
          conversations.map((conversation) => (
            <div
              key={conversation.id}
              className={`conversation-item ${
                selectedConversation?.id === conversation.id ? 'selected' : ''
              } ${conversation.unread_count > 0 ? 'unread' : ''}`}
              onClick={() => onSelectConversation(conversation)}
            >
              <div className="conversation-avatar">
                <div className="avatar-circle">
                  {conversation.contact.name?.charAt(0).toUpperCase() || '?'}
                </div>
              </div>
              <div className="conversation-info">
                <div className="conversation-header">
                  <span className="conversation-name">
                    {conversation.customer_match?.name ||
                      conversation.contact.name ||
                      conversation.contact.phone_number}
                  </span>
                  <span className="conversation-time">
                    {formatLastMessageTime(conversation.last_message_at)}
                  </span>
                </div>
                <div className="conversation-preview">
                  <span className="last-message">
                    {conversation.last_message_text ||
                      (typeof conversation.last_message === 'string'
                        ? conversation.last_message
                        : conversation.last_message?.message) ||
                      'No messages yet'}
                  </span>
                  {conversation.unread_count > 0 && (
                    <span className="unread-badge">{conversation.unread_count}</span>
                  )}
                </div>
                {(conversation.customer_match || conversation.booking_match) && (
                  <div className="conversation-links">
                    {conversation.customer_match && (
                      <a
                        className="conversation-link"
                        href={`/customers?search=${encodeURIComponent(
                          conversation.customer_match.phone || conversation.contact.phone_number
                        )}`}
                      >
                        Customer
                      </a>
                    )}
                    {conversation.booking_match && (
                      <a
                        className="conversation-link"
                        href={`/booking?search=${encodeURIComponent(
                          conversation.customer_match?.phone || conversation.contact.phone_number
                        )}`}
                      >
                        Booking
                      </a>
                    )}
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ConversationList;
